import { useGetAiMappingRunAreaResultsLazyQuery } from "generated/graphql";

export default function useGetAiMappingRunAreaResults() {
  const [fetch, { data, loading, error }] = useGetAiMappingRunAreaResultsLazyQuery();
  return [fetch, { data, loading, error }] as const;
}
